import { joinUrl } from "services/utils/join-urls";

export const endPoints = {
  tasks: joinUrl({ endpoint: "tasks" }),
  analytics_track: joinUrl({ endpoint: "analytics/track", isBaseCommon: true }),
};
